// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-icon.v-icon{color:#167ea2}.v-input__slot{align-items:normal}.v-input--selection-controls{margin-top:0!important}.v-input--is-dirty:not(.v-input--is-focused) label{opacity:1;color:#666;caret-color:#666}.v-input:not(.v-input--is-dirty) rect{stroke:#bdbdbd}.v-input--checkbox .v-input--selection-controls__input{margin-top:.1875rem}", ""]);
// Exports
module.exports = exports;
